import script from "./partners.vue?vue&type=script&setup=true&lang=js"
export * from "./partners.vue?vue&type=script&setup=true&lang=js"

import "./partners.vue?vue&type=style&index=0&id=dbc24810&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HP\\Desktop\\dashboard-pro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbc24810"]])

export default __exports__